export default "__VITE_ASSET__3OTdl$HY__"